import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { FloatingCTA } from './components/FloatingCTA';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/sections/Hero';
import { Problem } from './components/sections/Problem';
import { BeforeAfter } from './components/sections/BeforeAfter';
import { Pains } from './components/sections/Pains';
import { Volumes } from './components/sections/Volumes';
import { Extras } from './components/sections/Extras';
import { Bonuses } from './components/sections/Bonuses';
import { Offer } from './components/sections/Offer';
import { Guarantee } from './components/sections/Guarantee';
import { Testimonials } from './components/sections/Testimonials';
import { About } from './components/sections/About';
import { FAQ } from './components/sections/FAQ';
import { FinalCTA } from './components/sections/FinalCTA';
import { Footer } from './components/sections/Footer';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-cream font-sans text-ink antialiased" data-id="element-0" data-mp="3ikh9me1wn113">
      <MetaPixel data-id="element-1" data-mp="3ml17jjuay8oa" />
      <Hero data-id="element-2" data-mp="3mkhofzsx1e8o" />
      <main data-id="element-3" data-mp="3mjzuj9tq7c3x">
        <Problem data-id="element-4" data-mp="3mjpyp5m02aqb" />
        <BeforeAfter data-id="element-5" data-mp="3mj6lu3b7icj5" />
        <Pains data-id="element-6" data-mp="3rbrakqf99zft" />
        <Volumes data-id="element-7" data-mp="3rdaquh0wwahl" />
        <Extras data-id="element-8" data-mp="3rcsy3udgkeef" />
        <Bonuses data-id="element-9" data-mp="3recerm310rgq" />
        <Offer data-id="element-10" data-mp="5yk6vxnnffx" />
        <Guarantee data-id="element-11" data-mp="5opiv1o0k3w" />
        <Testimonials data-id="element-12" data-mp="4wvvprmowg9" />
        <About data-id="element-13" data-mp="5gg5d4r3wxg" />
        <FAQ data-id="element-14" data-mp="82kl3wchwbg" />
        <FinalCTA data-id="element-15" data-mp="7sxpp6lk59z" />
      </main>
      <Footer data-id="element-16" data-mp="2zlv7cvunj3vl" />
      <FloatingCTA data-id="element-17" data-mp="2zm4vedw4z0yn" />
      <PurchasePopup data-id="element-18" data-mp="2zmwi0z7r9ocs" />
    </div>;
}